/**
 * Image Modal Component
 * - Displays images in a maximized view
 * - Click outside or close button to dismiss
 * - Used for viewing enlarged images in details pages
 */

import React from "react";

const ImageModal = ({ open, onClose, imageSrc, altText = "Enlarged image" }) => {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50"
      onClick={onClose}
    >
      <div className="relative max-w-4xl max-h-full p-4">
        <img
          src={imageSrc}
          alt={altText}
          className="max-w-full max-h-full object-contain rounded-lg"
          onClick={(e) => e.stopPropagation()} // Prevent closing when clicking image
        />
        <button
          className="absolute top-2 right-2 text-white text-2xl bg-black bg-opacity-50 rounded-full w-10 h-10 flex items-center justify-center hover:bg-opacity-70 transition-opacity"
          onClick={onClose}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default ImageModal;
